    document.addEventListener("DOMContentLoaded", () => {

        const LIMIT = Number(document.getElementById("buy8-builder").dataset.limit);
        let selected = [];

        const countTop = document.getElementById("buy8-count");
        const countBottom = document.getElementById("buy8-selected-count");
        const progress = document.getElementById("buy8-progress-fill");
        const cartBtn = document.getElementById("buy8-cart-btn");
        const slots = document.querySelectorAll(".buy8-slot");

        function updateUI(){

            countTop.textContent = selected.length;
            countBottom.textContent = selected.length;

            progress.style.width = (selected.length / LIMIT) * 100 + "%";
            let subtotal = 0;

selected.forEach(item => {
    subtotal += Number(item.price);
});

const finalPrice = document.getElementById("buy8-final-price");
const originalPrice = document.getElementById("buy8-original-price");

if (selected.length === 0) {

    finalPrice.innerHTML = "₹0";
    originalPrice.innerHTML = "₹0";
    originalPrice.style.display = "none";

} else if (selected.length < LIMIT) {

    finalPrice.innerHTML = "₹" + (subtotal / 100).toFixed(0);

    originalPrice.style.display = "none";

} else {

    const BUNDLE_PRICE = Number(document.getElementById("buy8-builder").dataset.price);

finalPrice.innerHTML = "₹" + BUNDLE_PRICE;

    originalPrice.innerHTML = "₹" + (subtotal / 100).toFixed(0);

    originalPrice.style.display = "block";

}

        slots.forEach((slot,index)=>{

    slot.innerHTML="";

    if(selected[index]){

    slot.innerHTML=`

    <img src="${selected[index].image}">

    <div class="buy8-remove" data-index="${index}">×</div>

    `;

    }else{

    slot.innerHTML='<span class="slot-plus">+</span>';

    }

    });

            cartBtn.disabled = selected.length !== LIMIT;

            const msg=document.getElementById("buy8-message");

    if(msg){

    if(selected.length===LIMIT){

    msg.innerHTML="Ready To Checkout";

    }else{

    msg.innerHTML="Add "+(LIMIT-selected.length)+" More Item(s)";

    }

    }

            document.querySelectorAll(".buy8-add-btn").forEach(btn=>{

                const variant = btn.dataset.variant;

                if(selected.find(item=>item.variant==variant)){

                    btn.textContent="Added";
                    btn.disabled=true;

                }else if(selected.length>=LIMIT){

                    btn.disabled=true;

                }else{

                    btn.textContent="Add To Box";
                    btn.disabled=false;

                }

            });

        }
document.querySelectorAll(".buy8-add-btn").forEach(btn=>{

    btn.addEventListener("click",()=>{

        if(selected.length>=LIMIT) return;

        const card = btn.closest(".buy8-card");

        selected.push({

            variant: btn.dataset.variant,

            image: card.querySelector("img").src,

            price: Number(btn.dataset.price)

        });

        updateUI();

    });

});

        

        cartBtn.addEventListener("click", async ()=>{

            if(selected.length!==LIMIT) return;

            const items = selected.map(item=>({

                id:item.variant,

                quantity:1

            }));

            await fetch('/cart/clear.js',{
                method:'POST'
            });

            await fetch('/cart/add.js',{

                method:'POST',

                headers:{
                    'Content-Type':'application/json'
                },

                body:JSON.stringify({
                    items:items
                })

            });

            if (typeof shiprocketCheckoutEvents !== "undefined") {

    shiprocketCheckoutEvents.buyCart();

} else {

window.location="/checkout";
}

        });

        /* ===========================
    SEARCH PRODUCTS
    =========================== */

   const searchInput = document.getElementById("buy8-search");
const searchWrap = document.querySelector(".buy8-search-wrap");
const searchIcon = document.querySelector(".buy8-search-icon");

if (searchInput) {

    searchWrap.addEventListener("click", function () {

        searchInput.classList.add("active");
        searchInput.focus();

    });

    searchInput.addEventListener("focus", function () {

        searchInput.classList.add("active");

        if(searchIcon){
           searchIcon.style.opacity = "0";
        }

    });

    searchInput.addEventListener("blur", function () {

        if (searchInput.value === "") {

            searchInput.classList.remove("active");

            if(searchIcon){
               searchIcon.style.opacity = "1";
            }

        }

    });

    searchInput.addEventListener("keyup", function () {

        const keyword = this.value.toLowerCase();

        document.querySelectorAll(".buy8-card").forEach(card => {

            const title = card.querySelector(".buy8-title").innerText.toLowerCase();

            if (title.indexOf(keyword) > -1) {
                card.style.display = "";
            } else {
                card.style.display = "none";
            }

        });

    });

}

    /* ===========================
    SORT PRODUCTS
    =========================== */

    const sortSelect = document.getElementById("buy8-sort");

    if (sortSelect) {

        sortSelect.addEventListener("change", function () {

            const grid = document.querySelector(".buy8-grid");

            let cards = Array.from(document.querySelectorAll(".buy8-card"));

            switch (this.value) {

                case "price-ascending":

                    cards.sort((a, b) => {

                        return parseFloat(
                            a.querySelector(".buy8-price").innerText.replace(/[^\d.]/g, "")
                        ) -

                        parseFloat(
                            b.querySelector(".buy8-price").innerText.replace(/[^\d.]/g, "")
                        );

                    });

                    break;


                case "price-descending":

                    cards.sort((a, b) => {

                        return parseFloat(
                            b.querySelector(".buy8-price").innerText.replace(/[^\d.]/g, "")
                        ) -

                        parseFloat(
                            a.querySelector(".buy8-price").innerText.replace(/[^\d.]/g, "")
                        );

                    });

                    break;


                case "title-ascending":

                    cards.sort((a, b) => {

                        return a.querySelector(".buy8-title").innerText.localeCompare(
                            b.querySelector(".buy8-title").innerText
                        );

                    });

                    break;


                case "title-descending":

                    cards.sort((a, b) => {

                        return b.querySelector(".buy8-title").innerText.localeCompare(
                            a.querySelector(".buy8-title").innerText
                        );

                    });

                    break;

            }

            cards.forEach(card => grid.appendChild(card));

        });

    }

        updateUI();

        document.addEventListener("click",(e)=>{

    if(e.target.classList.contains("buy8-remove")){

    selected.splice(e.target.dataset.index,1);

    updateUI();

    }

    });

    });